import Api from "./api";

export const getPaginateByLlmDocumentId = async (llmDocumentId, page) => {
    try {
        console.log(`Fetching status history for LLM Document ID: ${llmDocumentId}, Page: ${page}`);
        const response = await Api.get(`llmdocumentstatushistory/${llmDocumentId}/paginate?page=${page}`);
        return response.data;
    } catch (err) {
        throw err;
    }
}